import { useEffect, useCallback } from "react";
import { useParameter, useFavouriteProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";

export function useFavourite() {
  const title = useSlideTitle();
  const {
    actions: { setParameters, setApplyFunction },
  } = useFavouriteProviderContext();

  const [method, setMethod] = useParameter<number>("@method");

  useEffect(() => {
    setParameters(title, {
      "@method": method,
    });
  }, [title, method, setParameters]);

  const applyParameters = useCallback(
    (parameters: Record<string, string[]>) => {
      setMethod(parameters["@method"].map(Number)[0]);
    },
    [setMethod]
  );

  useEffect(() => {
    setApplyFunction(applyParameters);
  }, [setApplyFunction, applyParameters]);
}
